module.exports = __webpack_public_path__ + "files/ad1163f589e45be403834563a21c5944.svg";